import { Controller } from 'stimulus';
import Swiper from 'swiper';

class Collaborators extends Controller {
  connect() {
    // eslint-disable-next-line no-new
    new Swiper(this.element, {
      slidesPerView: 'auto',
      spaceBetween: 45,
      freeMode: true,
      breakpoints: {
        992: {
          spaceBetween: 60,
        },
        1200: {
          spaceBetween: 100,
        },
      },
    });
  }
}

export default Collaborators;
